<template>
    <van-config-provider :theme-vars="themeVars" style="height: 100vh;">
        <router-view />
    </van-config-provider>
</template>

<script setup>
import {getCurrentInstance} from "vue";

const {proxy} = getCurrentInstance()
const themeVars = {
    buttonPrimaryBorderColor: '#00B075',
    buttonPrimaryBackgroundColor: '#00B075',
}

</script>

<style lang="scss">
body{
    margin: 0;
    padding: 0;
}
#app {
    height: 100vh;
}
</style>